import PropTypes from 'prop-types';
import clsx from 'clsx';

import { Card, CardContent, Divider, Table, TableBody, TableCell, TableRow } from '@mui/material';
import AdjustedSkeleton from '../AdjustedSkeleton';

import { useStyles } from './style';

const LoadingDetailsBlock = props => {
	const classes = useStyles();

	const { className } = props;

	return (
		<Card className={clsx(classes.root, className)}>
			<div className={classes.header}>
				<AdjustedSkeleton animation='wave' width='50%' />
			</div>
			<Divider />
			<CardContent className={classes.content}>
				<Table>
					<TableBody>
						<TableRow>
							<TableCell><AdjustedSkeleton animation='wave' /></TableCell>
							<TableCell><AdjustedSkeleton animation='wave' /></TableCell>
						</TableRow>
						<TableRow>
							<TableCell><AdjustedSkeleton animation='wave' /></TableCell>
							<TableCell><AdjustedSkeleton animation='wave' /></TableCell>
						</TableRow>
						<TableRow>
							<TableCell><AdjustedSkeleton animation='wave' /></TableCell>
							<TableCell><AdjustedSkeleton animation='wave' /></TableCell>
						</TableRow>
						<TableRow>
							<TableCell><AdjustedSkeleton animation='wave' /></TableCell>
							<TableCell><AdjustedSkeleton animation='wave' /></TableCell>
						</TableRow>
					</TableBody>
				</Table>
			</CardContent>
		</Card>
	);
};

LoadingDetailsBlock.propTypes = {
	className: PropTypes.string,
};

export default LoadingDetailsBlock;